/* =====================================================================
   SH4DE — Pop-up −5 % : inscription e-mail (+ SMS facultatif) via Klaviyo
   Prend la main sur l'envoi du formulaire de la pop-up (#kr-nl-form).
   - Seul l'e-mail est obligatoire pour débloquer le code.
   - Le numéro est facultatif : la case SMS apparaît dès qu'il est saisi,
     et le numéro n'est envoyé à Klaviyo que si la case est cochée.
   - Shopify reçoit l'e-mail seul (abonnement newsletter), sans bloquer.
   ===================================================================== */
(function () {
  'use strict';
  var doc = document;
  var REVISION = '2026-07-15';
  var LS = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  var T = function (k, d) { return window.SH4DE_T ? window.SH4DE_T(k, d) : d; };
  // Indicatif selon le pays du visiteur (Shopify) ou la langue de la page. [indicatif, retirer le 0 initial]
  var CC = { FR: ['33', 1], BE: ['32', 1], LU: ['352', 0], NL: ['31', 1], DE: ['49', 1], AT: ['43', 1], ES: ['34', 0], PT: ['351', 0], IT: ['39', 0], PL: ['48', 0] };
  function country() {
    var c = (window.Shopify && window.Shopify.country) || '';
    if (window.SH4DE_LANG === 'es' && (c === 'FR' || !c)) c = 'ES';
    return CC[c] ? c : 'FR';
  }
  // Numéro national ou international -> format E.164 (+33612345678), sinon ''
  function normPhone(v) {
    var s = String(v || '').replace(/[\s.\-()\/]/g, '');
    if (/^00\d+$/.test(s)) s = '+' + s.slice(2);
    if (s.charAt(0) !== '+') {
      var c = CC[country()];
      if (c[1] && /^0\d{6,13}$/.test(s)) s = '+' + c[0] + s.slice(1);
      else if (/^\d{6,13}$/.test(s)) s = '+' + c[0] + s;
    }
    if (/^\+330\d{9}$/.test(s)) s = '+33' + s.slice(4);
    return /^\+[1-9]\d{7,14}$/.test(s) ? s : '';
  }

  // La case SMS n'apparaît que si un numéro est saisi.
  doc.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || el.name !== 'phone') return;
    var form = el.closest('#kr-nl-form');
    var box = form && form.querySelector('[data-pop-consent]');
    if (box) box.hidden = !el.value.trim();
  });

  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== 'kr-nl-form') return;
    var pop = form.closest('[data-kr-pop]');
    if (!pop) return;

    // On remplace le gestionnaire d'origine (qui n'envoyait que l'e-mail à Shopify)
    e.preventDefault();
    e.stopPropagation();

    var err = pop.querySelector('[data-pop-err]');
    var btn = form.querySelector('.kr-pop__btn');
    var formWrap = pop.querySelector('[data-pop-form-wrap]');
    var done = pop.querySelector('[data-pop-done]');
    var code = pop.getAttribute('data-code') || '';
    var company = pop.getAttribute('data-k-company');
    var list = pop.getAttribute('data-k-list');

    var emailIn = form.querySelector('input[type=email]');
    var phoneIn = form.querySelector('input[name=phone]');
    var consentIn = form.querySelector('input[name=sms_consent]');

    function showErr(msg) {
      err.textContent = msg || T('err_generic', 'Une erreur est survenue. Vérifie tes infos et réessaie.');
      err.hidden = false;
    }
    err.hidden = true;

    var email = (emailIn && emailIn.value || '').trim();
    var rawPhone = (phoneIn && phoneIn.value || '').trim();
    var phone = normPhone(rawPhone);
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { showErr(T('err_email', 'Entre ton adresse e-mail.')); emailIn && emailIn.focus(); return; }
    if (rawPhone && !phone) { showErr(T('err_phone', 'Numéro invalide. Exemple : 06 12 34 56 78')); phoneIn.focus(); return; }
    if (phone && consentIn && !consentIn.checked) { showErr(T('err_consent', 'Coche la case pour recevoir les SMS, ou laisse le numéro vide.')); return; }
    if (!company || !list) { showErr(); return; }

    btn && btn.classList.add('is-load');

    var attrs = { email: email };
    if (phone && consentIn && consentIn.checked) attrs.phone_number = phone;

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Pop-up SH4DE -5% (sh4de.fr' + (window.SH4DE_LANG && window.SH4DE_LANG !== 'fr' ? ' ' + window.SH4DE_LANG : '') + ')',
          profile: { data: { type: 'profile', attributes: attrs } }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };

    var klaviyo = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': REVISION
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.ok) return;
      return r.json().catch(function () { return {}; }).then(function (j) {
        var d = j && j.errors && j.errors[0];
        var txt = d ? ((d.detail || '') + ' ' + ((d.source && d.source.pointer) || '')) : '';
        throw new Error(/phone/i.test(txt) ? 'phone' : (/email/i.test(txt) ? 'email' : 'klaviyo'));
      });
    });

    // Shopify : abonnement newsletter avec l'e-mail seul (non bloquant)
    try {
      var fd = new FormData(form);
      fd.delete('phone');
      fd.delete('sms_consent');
      fetch(form.action, { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {});
    } catch (x) {}

    klaviyo
      .then(function () {
        if (!code) return;
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      })
      .then(function () {
        formWrap.hidden = true;
        done.hidden = false;
        var b = done.querySelector('[data-pop-code]'); if (b) b.textContent = code;
        LS.set('kr-nl', code || '1');
        // Klaviyo reconnaît ce visiteur pour la suite (relances navigation / panier)
        try { if (window.klaviyo) window.klaviyo.push(['identify', attrs]); } catch (z) {}
        Array.prototype.forEach.call(doc.querySelectorAll('[data-nl-off]'), function (x) { x.hidden = true; });
        Array.prototype.forEach.call(doc.querySelectorAll('[data-nl-on]'), function (x) { x.hidden = false; });
      })
      .catch(function (x) {
        var m = x && x.message;
        if (m === 'phone') showErr(T('err_phone_refused', 'Ce numéro a été refusé. Vérifie-le (ex. 06 12 34 56 78).'));
        else if (m === 'email') showErr(T('err_email_refused', 'Cette adresse e-mail a été refusée. Vérifie-la.'));
        else showErr();
      })
      .then(function () { btn && btn.classList.remove('is-load'); });
  }, true);
})();
